import React, { useContext } from 'react'
import { FC, useEffect } from 'react'
import { MenuComponent } from '../../../../../../_metronic/assets/ts/components'
import { KTSVG } from '../../../../../../_metronic/helpers'
import { Link } from 'react-router-dom'
import { canWritePartnersContext } from '../../../Partner'
import Partner from '../../../../../interfaces/Partner'

type Props = {
  user: Partner
}

const PartnerActionsCell: FC<Props> = ({ user }) => {
  const canWrite = useContext(canWritePartnersContext)

  useEffect(() => {
    MenuComponent.reinitialization()
  }, [])

  return (
    <>
      {canWrite && (
        <div style={{ display: 'flex', justifyContent: 'end' }}>
          <Link to={`/catalogo/partner/modifica-partner/${user.id}`}>
            <button
              type="button"
              className="btn btn-light-primary me-3"
              data-kt-menu-trigger="click"
              data-kt-menu-placement="bottom-end">
              <KTSVG
                path="/media/icons/duotune/general/gen055.svg"
                className="svg-icon-2"
              />
              Modifica
            </button>
          </Link>
          {false && (
            <Link
              to={`/catalogo/offerte-articoli/nuova-offerta/?partnerId/${user.id}`}>
              <button
                type="button"
                className="btn btn-light-primary me-3"
                data-kt-menu-trigger="click"
                data-kt-menu-placement="bottom-end">
                <KTSVG
                  path="/media/icons/duotune/arrows/arr075.svg"
                  className="svg-icon-2"
                />
                Aggiungi offerta
              </button>
            </Link>
          )}
        </div>
      )}
    </>
  )
}

export { PartnerActionsCell }
